export default "__VITE_ASSET__BxglBSdy__"